<template>
  <div class="flex gap-base">
    <button
      @click="setShowCardView(false)"
      class="bg-transparent border-none p-0 flex items-center"
      :class="showCard ? 'cursor-pointer text-signableBrandColours-midGrey hover:text-signableBrandColours-darkGrey' : 'text-signableBrandColours-black'"
      data-test="list-button"
      data-ec="list_or_card_view_switcher"
      data-et="view_switched_to_list"
      :aria-label="$t('library.viewSwitchers.listOrCardViewSwitcher.switchToListView')"
    >
      <ListViewIcon aria-hidden="true" />
    </button>
    <button
      @click="setShowCardView(true)"
      class="bg-transparent border-none p-0 group flex items-center"
      :class="showCard ? 'text-signableBrandColours-black' : 'cursor-pointer text-signableBrandColours-midGrey hover:text-signableBrandColours-darkGrey'"
      data-test="card-button"
      data-ec="list_or_card_view_switcher"
      data-et="view_switched_to_card"
      :aria-label="$t('library.viewSwitchers.listOrCardViewSwitcher.switchToCardView')"
    >
      <CardViewIcon aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { ListViewIcon, CardViewIcon } from '@/components/library/icons';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    defaultShowCard: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ListViewIcon,
    CardViewIcon,
  },
  data() {
    return {
      showCard: this.defaultShowCard,
    };
  },
  methods: {
    setShowCardView(setting) {
      if (this.showCard !== setting) {
        this.showCard = setting;
        this.$emit('setShowCardView', this.showCard);
      }
    },
  },
});
</script>
